<template>
  <div class="photo-toast">
    <div class="toast-close" @click="closeToast"></div>
    <div class="toast">
      <div class="toast-content">
        <h3 class="toast-title">照片发上屏&nbsp;&nbsp;&nbsp;&nbsp; 全场都暴富</h3>
        <p class="toast-text">{{ text }}</p>
        <div class="upload-section">
          <div class="upload-section-content" :class="uploadedPics.length > 2 && 'uploaded-pics-center'">
            <div class="uploaded-pics" v-if="uploadedPics.length > 0">
              <div class="pic" v-for="(pic, index) in uploadedPics" :key="index">
                <div class="delete-btn" @click="deletePhoto(index)"></div>
                <div class="pic-content" :style="`background-image: url(${pic});`"></div>
              </div>
            </div>
            <div class="upload-btn" v-if="uploadedPics.length < imgnum" @click="uploadPhoto">
              上传照片({{uploadedPics.length}}/{{imgnum}})
              <span class="red-dot"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="send-btn-section">
        <i v-if="!hasPrivilege && !isLoading" class="tip">￥{{parentParams.price/100}}</i>
        <button class="send-btn" @click="sendPhotoToScreen">发送上屏</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import sendPhoto from '@/mixins/send_photo'

export default {
  data() {
    return {
      uploadedPics: [],
      hasPrivilege: false,
      parentParams: {},
      entrance: 'photo_toast',
      isLoading: true,
    };
  },
  mixins: [sendPhoto],
  props: {
    fromType: String,
  },
  computed: {
    ...mapState({
      openid: (state) => state.openid,
      unionid: (state) => state.unionid,
      photoPag: (state) => state.photoPag,
      photoToastEntrance: (state) => state.photoToastEntrance,
      photoPath: (state) => state.photoPath,
    }),
    text() {
      return this.hasPrivilege ? '已开通，照片无限次数上屏' : '开通后，照片无限次数上屏';
    },
    imgnum() {
      return this.photoPath.id === 1 ? 1 : 6;
    }
  },
  methods: {
    closeToast() {
      this.$store.commit('SET_SHOW_PHOTO_TOAST', false);
    },
    deletePhoto(index) {
      this.uploadedPics.splice(index, 1);
    },
    sendPhotoToScreen() {
      this.$sendLog({
        event_type: 'click',
        event_name: '发照片弹窗-点击',
        event_data: {
          fromType: this.photoToastEntrance,
          name: this.photoPath.label,
        }
      })
      if (this.hasPrivilege || !this.isLoading) {
        this.$sendLog({
          event_type: 'click',
          event_name: '发照片弹窗-点击发送',
          event_data: {
            fromType: this.photoToastEntrance,
            name: this.photoPath.label,
          }
        })
      }
      this.handleSend(this.entrance)
    }
  },
  mounted() {
    this.$sendLog({
      event_type: 'click',
      event_name: '发照片弹窗-展示',
      event_data: {
        fromType: this.photoToastEntrance,
        name: this.photoPath.label,
      }
    })
    this.getDefault()
    this.entrance = `${this.photoToastEntrance}_${this.photoPath.entrance}` || `photoT_${this.$route.name}`
  }
};
</script>

<style lang="scss" scoped>
.photo-toast {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.8);
}

.toast-close {
  position: absolute;
  top: 90px;
  right: 50px;
  width: 60px;
  height: 60px;
  background: url('https://qncweb-back1.ktvsky.com/20240912/vadd/2ea871a7ae89d3ddf55722505052ff2f.png') no-repeat center center;
  background-size: contain;
}

.toast-content {
  position: relative;
  width: 750px;
  height: 565px;
  background: url('https://qncweb-back1.ktvsky.com/20240911/vadd/c38934f23f41e0d006f8ebf545637253.png') no-repeat center center;
  background-size: contain;
  padding-top: 50px;
  border-radius: 20px;
}

.toast-title {
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  background: linear-gradient(180deg, #FF9900 0%, #FFCC19 10%, #FFFFFF 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}

.toast-text {
  font-size: 30px;
  color: #fff;
  margin-top: 6px;
  text-align: center;
}

.upload-section {
  width: 690px;
  height: 187px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin: 35px auto 0;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display:none;
  }
}

.upload-section-content {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: center;
}

.uploaded-pics-center {
  width: fit-content;
}

.uploaded-pics {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  width: fit-content;
}

.pic {
  position: relative;
  width: 172px;
  height: 172px;
  margin: 15px 10px 0 0;
  border-radius: 30px;
}

.delete-btn {
  position: absolute;
  top: -15px;
  right: 4px;
  width: 40px;
  height: 40px;
  background: url('https://qncweb.ktvsky.com/20250214/vadd/a9eb91dbebe083ff33369f85f437fefc.png') no-repeat center center;
  background-size: contain;
  z-index: 1;
  cursor: pointer;
}

.pic-content {
  width: 100%;
  height: 100%;
  background-size: cover;
  border: 1px solid #fff;
  border-radius: 30px;
  background-position: center;
  background-repeat: no-repeat;
}

.upload-btn {
  width: 172px;
  height: 172px;
  padding-top: 100px;
  color: #000;
  border-radius: 30px;
  background: #E6E6E6 url('https://qncweb-back1.ktvsky.com/20240912/vadd/4c8af338357ba43fd5201659297d5ec0.png') no-repeat 54px 35px;
  background-size: 64px 64px;
  font-size: 20px;
  text-align: center;
  margin-top: 15px;
  position: relative;
  .red-dot {
    position: absolute;
    top: 35px;
    right: 55px;
    width: 15px;
    height: 15px;
    background-color: red;
    border-radius: 50%;
    display: inline-block;
  }
}

.send-btn-section {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}

.tip {
  display: block;
  position: absolute;
  top: -10px;
  right: 224px;
  color: #fff;
  border-radius: 15px 15px 15px 0;
  background: #FF334E;
  padding: 3px 10px;
  font-size: 24px;
}

.send-btn {
  width: 618px;
  height: 90px;
  background-color: #FFC43D;
  color: #5C3000;
  border: none;
  font-size: 30px;
  border-radius: 50px;
}
</style>
